// +----------------------------------------------------------------------
// | Desc:导入全局配置
// +----------------------------------------------------------------------
import Vue from "vue";

// +----------------------------------------------------------------------
// | Desc:loginOut
// +----------------------------------------------------------------------
Vue.prototype.$loginOut = function (isRole) {
  let that = this;
  this.$Modal.confirm({
    title: "退出登录提示",
    content: "<p>您确认要退出登录吗 ？</p>",
    onOk: () => {
      that.$clearStorage();
      localStorage.setItem("token", null);
      localStorage.setItem("user", null);
      that.$msg("成功退出登录", "success", 1000, function () {
        that.$go("/login");
      });
    },
  });
};
// +----------------------------------------------------------------------
// | Desc:登录数据取citySon
// +----------------------------------------------------------------------
Vue.prototype.$numToArr = function (number) {
  let numberString = number.toString(); // 将数字转换成字符串
  let numberArray = numberString.split(''); // 按照空字符串分隔字符串，得到数组
  return numberArray;
};
// +----------------------------------------------------------------------
// | Desc:登录数据取cityFuqin
// +----------------------------------------------------------------------
Vue.prototype.$getCityFuqin = function (key) {
  var cityFuqin = this.$getLocalStorage("cityFuqin");
  if (!this.$isblank(cityFuqin)) {
    return cityFuqin[key];
  } else {
    return "";
  }
};

// +----------------------------------------------------------------------
// | Desc:登录数据取USER
// +----------------------------------------------------------------------
Vue.prototype.$getUser = function (key) {
  var user = this.$getLocalStorage("user");
  console.log(user);
  if (!this.$isblank(user)) {
    return user[key];
  } else {
    return "";
  }
};

// +----------------------------------------------------------------------
// | Desc:格式化行政区划代码
// +----------------------------------------------------------------------
Vue.prototype.$FMTCode = function (code) {
  if (code.endsWith("000000")) {
    code = code.slice(0, -6); // 去掉最后三个0
  } else if (code.endsWith("000")) {
    code = code.slice(0, -3);
  }
  return code;
};

// +----------------------------------------------------------------------
// | @Des查询地图边界点
// +----------------------------------------------------------------------

Vue.prototype.$fitBounds = function (latLngList) {
  if (latLngList.length === 0) {
    return null;
  }
  var boundsN = latLngList[0].getLat();
  var boundsS = boundsN;
  var boundsW = latLngList[0].getLng();
  var boundsE = boundsW;
  latLngList.forEach((point) => {
    point.getLat() > boundsN && (boundsN = point.getLat());
    point.getLat() < boundsS && (boundsS = point.getLat());
    point.getLng() > boundsE && (boundsE = point.getLng());
    point.getLng() < boundsW && (boundsW = point.getLng());
  });
  return new TMap.LatLngBounds(new TMap.LatLng(boundsS, boundsW), new TMap.LatLng(boundsN, boundsE));
};

// +----------------------------------------------------------------------
// | Desc:获取2024年到当年的年份列表+当年年份
// +----------------------------------------------------------------------
Vue.prototype.$getYear = function (type) {
  const startYear = 2024;
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  };

  if(type=='list'){
    return years;
  };
  if(type=='year'){
    return currentYear; 
  };
  return {
    years: years,
    currentYear: currentYear,
  };
};

// +----------------------------------------------------------------------
// | Desc:登录数据取citySon
// +----------------------------------------------------------------------
Vue.prototype.$getCitySon = function () {
  var citySon = this.$getLocalStorage("citySon");
  return citySon;
};

// +----------------------------------------------------------------------
// | Desc:行车路线地图弹窗
// +----------------------------------------------------------------------
Vue.prototype.$openLineMap = function (NO) {
  // 获取浏览器的高度和宽度
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  // 减去上下左右各30像素的边距
  const availableHeight = windowHeight - 60;
  const availableWidth = windowWidth - 60;

  // 取较小的值作为正方形的最大可能高度，并限制最大高度不超过600像素
  const squareSize = Math.min(availableHeight, availableWidth);
  const maxSquareSize = Math.min(squareSize, 2000);

  // 使用 maxSquareSize 作为弹窗的大小
  this.$QHopen.url(this.$httpServerH5("/electronicbillmap?NO=" + NO), 100, 100);
};
// +----------------------------------------------------------------------
// | Desc:清理缓存
// +----------------------------------------------------------------------
Vue.prototype.$clearStorage = function (str) {
  this.$setLocalStorage("user", null);
  this.$setLocalStorage("token", null);
  this.$setLocalStorage("city", null);
  this.$setLocalStorage("cityFuqin", null);
  this.$setLocalStorage("citySon", null);
  this.$setLocalStorage("addressFull", null);
};


// +----------------------------------------------------------------------
// | Desc:运输超时，获取当前十位数时间戳和传入时间戳对比大于5小时返回为true
// +----------------------------------------------------------------------
Vue.prototype.$isYunshuChaoshi = function (str) {
  if (this.$isblank(str)) return false;
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const diffSeconds = currentTimestamp - Number(str);
  return diffSeconds > 5 * 3600; // 5小时=18000秒
};


// +----------------------------------------------------------------------
// | Desc:进入企业大屏
// +----------------------------------------------------------------------
Vue.prototype.$goQiyeBigscreen = function (orgId, roleLoginLastId) {
  var token = localStorage.getItem("token");
  if (this.$isblank(token)) {
    this.$msg("登录信息过期，请退出重新进入", "error");
    return;
  }
  if (this.$isblank(orgId)) {
    this.$msg("单位ID丢失", "error");
    return;
  }
  if (this.$isblank(roleLoginLastId)) {
    this.$msg("单位角色丢失", "error");
    return;
  }
  var gov = {
    orgId: orgId,
    roleLoginLastId: roleLoginLastId,
    token: token,
  };
  var gov = this.$encrypt(JSON.stringify(gov));
  var url = this.$httpQiyebigscreen("/loginGov?gov=" + gov);
  window.open(url, '_blank'); // 在新窗口中打开
  // this.$QHopen.url(url, 100, 100,65,'退出企业');
};
